export type PendingBasketChange = { amount: number; voucherCode: string | null; hasAddonSalePrice?: boolean }

// What the customer actually changed in the basket and the client has not seen confirmed by a basket read yet.
// Shared by addProductToBasket (which sends and clears it) and the basket store (whose setBasket must not let
// an older basket read overwrite these amounts - deleting several products in a row made them flash back).
export const pendingBasketChanges = new Map<number, PendingBasketChange>()
